import { __decorate, __param, __metadata, __awaiter } from 'tslib';
import { InjectionToken, Optional, Inject, PLATFORM_ID, RendererFactory2, Injectable, Component, ChangeDetectionStrategy, EventEmitter, Input, Output, forwardRef, Renderer2, ViewChild, ElementRef, NgModule } from '@angular/core';
import { BehaviorSubject, combineLatest, of, never } from 'rxjs';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import { set, get, remove } from 'js-cookie';
import { skip, shareReplay, map, take } from 'rxjs/operators';
import { FormBuilder, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

/**
 * Possible view states for the cookie consent
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';

function UniversalCookieConsentComponent_ng_container_0_ng_container_1_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function UniversalCookieConsentComponent_ng_container_0_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, UniversalCookieConsentComponent_ng_container_0_ng_container_1_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function UniversalCookieConsentComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtemplate(3, UniversalCookieConsentComponent_ng_container_0_ng_container_1_ng_container_3_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵpipe(4, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(6);
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(4, 2, ctx_r2.viewState$) === ctx_r2.ViewState.SIMPLE)("ngIfElse", _r5);
} }
function UniversalCookieConsentComponent_ng_container_0_ng_template_3_img_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 12);
} if (rf & 2) {
    const options_r1 = ɵngcc0.ɵɵnextContext(2).ngIf;
    ɵngcc0.ɵɵproperty("src", options_r1.logoUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function UniversalCookieConsentComponent_ng_container_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵtemplate(0, UniversalCookieConsentComponent_ng_container_0_ng_template_3_img_0_Template, 1, 1, "img", 7);
    ɵngcc0.ɵɵelement(1, "p", 8);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵelementStart(3, "button", 10);
    ɵngcc0.ɵɵlistener("click", function UniversalCookieConsentComponent_ng_container_0_ng_template_3_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.onCustomizeClicked(); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 11);
    ɵngcc0.ɵɵlistener("click", function UniversalCookieConsentComponent_ng_container_0_ng_template_3_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.onAcceptClicked(); });
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const options_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵproperty("ngIf", options_r1.logoUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", options_r1.introText, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(options_r1.customizeText);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(options_r1.acceptText);
} }
function UniversalCookieConsentComponent_ng_container_0_ng_template_5_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelement(1, "ui-switch", 18);
    ɵngcc0.ɵɵelementStart(2, "div", 19);
    ɵngcc0.ɵɵelementStart(3, "h2", 20);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "p", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const consentType_r16 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("color", consentType_r16.color);
    ɵngcc0.ɵɵproperty("formControlName", consentType_r16.id);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(consentType_r16.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", consentType_r16.description, ɵngcc0.ɵɵsanitizeHtml);
} }
function UniversalCookieConsentComponent_ng_container_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "h1", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "p", 14);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "form", 15);
    ɵngcc0.ɵɵtemplate(5, UniversalCookieConsentComponent_ng_container_0_ng_template_5_div_5_Template, 6, 5, "div", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 9);
    ɵngcc0.ɵɵelementStart(7, "button", 10);
    ɵngcc0.ɵɵlistener("click", function UniversalCookieConsentComponent_ng_container_0_ng_template_5_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.onBackClicked(); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "button", 11);
    ɵngcc0.ɵɵlistener("click", function UniversalCookieConsentComponent_ng_container_0_ng_template_5_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.onSaveCustomizedClicked(); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const options_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(options_r1.customizeHeadingText);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(options_r1.customizeIntroText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r6.customizeFormGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", options_r1.consentTypes);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(options_r1.backText);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(options_r1.saveText);
} }
function UniversalCookieConsentComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, UniversalCookieConsentComponent_ng_container_0_ng_container_1_Template, 5, 4, "ng-container", 0);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtemplate(3, UniversalCookieConsentComponent_ng_container_0_ng_template_3_Template, 7, 4, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(5, UniversalCookieConsentComponent_ng_container_0_ng_template_5_Template, 11, 6, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.showModal$));
} }
const _c0 = ["checkbox"];
var UniversalCookieConsentViewState;
(function (UniversalCookieConsentViewState) {
    UniversalCookieConsentViewState[UniversalCookieConsentViewState["CLOSED"] = 0] = "CLOSED";
    UniversalCookieConsentViewState[UniversalCookieConsentViewState["SIMPLE"] = 1] = "SIMPLE";
    UniversalCookieConsentViewState[UniversalCookieConsentViewState["ADVANCED"] = 2] = "ADVANCED";
})(UniversalCookieConsentViewState || (UniversalCookieConsentViewState = {}));

const UNIVERSAL_COOKIE_CONSENT_OPTIONS = new InjectionToken('UniversalCookieConsentOptions');

const UNIVERSAL_COOKIE_CONSENT_NAMESPACE = 'ucc';
/**
 * Write a new key value pair to the cookies
 * @param key
 * @param value
 * @param options
 */
function writeCookie(key, value, options) {
    if (options) {
        set(`${UNIVERSAL_COOKIE_CONSENT_NAMESPACE}_${key}`, JSON.stringify(value), options);
    }
    else {
        set(`${UNIVERSAL_COOKIE_CONSENT_NAMESPACE}_${key}`, JSON.stringify(value));
    }
}
/**
 * Read the value of the cookie with the given key
 * @param key
 */
function readCookie(key) {
    const value = get(`${UNIVERSAL_COOKIE_CONSENT_NAMESPACE}_${key}`);
    if (value) {
        try {
            return JSON.parse(value);
        }
        catch (e) {
            return null;
        }
    }
    else {
        return null;
    }
}
/**
 * Clear the key from the cookies
 */
function clearCookie(key) {
    remove(`${UNIVERSAL_COOKIE_CONSENT_NAMESPACE}_${key}`);
}

const UNIVERSAL_COOKIE_CONSENT_CONSENTS_KEY = 'consents';
/** @dynamic */
let UniversalCookieConsentService = class UniversalCookieConsentService {
    constructor(defaultOptions, document, platformId, rendererFactory) {
        this.defaultOptions = defaultOptions;
        this.document = document;
        this.platformId = platformId;
        /**
         * The current view state
         */
        this.viewState$ = new BehaviorSubject(UniversalCookieConsentViewState.CLOSED);
        /**
         * The current options
         */
        this.options$ = new BehaviorSubject(null);
        /**
         * The currently granted consents
         */
        this.grantedConsents$ = new BehaviorSubject(null);
        this.renderer = rendererFactory.createRenderer(null, null);
        this.options$.next(defaultOptions);
        if (isPlatformBrowser(platformId)) {
            combineLatest(this.viewState$, this.options$).subscribe(([viewState, options]) => {
                this.updateBodyScroll(viewState, options);
            });
            const grantedConsents = readCookie(UNIVERSAL_COOKIE_CONSENT_CONSENTS_KEY);
            this.grantedConsents$.next(grantedConsents);
            this.grantedConsents$.pipe(skip(1)).subscribe((consents) => this.onConsentsUpdated(consents));
            combineLatest([this.viewState$, this.options$, this.grantedConsents$]).subscribe(([viewState, options, consents]) => {
                this.handleAutoShow(viewState, options, consents);
            });
        }
    }
    getGrantedConsents() {
        return this.grantedConsents$.asObservable();
    }
    setGrantedConsents(consents) {
        this.grantedConsents$.next(consents);
    }
    /**
     * Get the current view state
     */
    getViewState() {
        return this.viewState$.asObservable();
    }
    /**
     * Get the current options
     */
    getOptions() {
        return this.options$.asObservable();
    }
    /**
     * Set the current view state
     * @param viewState
     */
    setViewState(viewState) {
        this.viewState$.next(viewState);
    }
    /**
     * Set the cookie consent options
     * @param options
     */
    setOptions(options) {
        const defaultOptions = this.defaultOptions || {
            consentTypes: []
        };
        this.options$.next(Object.assign(Object.assign({}, defaultOptions), options));
    }
    show(optionsOrShowAdvanced, options) {
        let showAdvanced = false;
        if (optionsOrShowAdvanced && typeof optionsOrShowAdvanced === 'boolean') {
            showAdvanced = optionsOrShowAdvanced;
        }
        else {
            options = optionsOrShowAdvanced;
        }
        if (options) {
            this.setOptions(options);
        }
        this.setViewState(showAdvanced ? UniversalCookieConsentViewState.ADVANCED : UniversalCookieConsentViewState.SIMPLE);
    }
    /**
     * Called when the granted consents have changed
     * @param consents
     */
    onConsentsUpdated(consents) {
        if (consents !== null) {
            const cookieSettings = this.options$.value.cookieSettings;
            writeCookie(UNIVERSAL_COOKIE_CONSENT_CONSENTS_KEY, consents, cookieSettings);
        }
        else {
            clearCookie(UNIVERSAL_COOKIE_CONSENT_CONSENTS_KEY);
        }
    }
    /**
     * Update the body element's overflow property as needed
     */
    updateBodyScroll(viewState, options) {
        const body = this.document.body;
        if (options.disableBodyScroll &&
            (viewState === UniversalCookieConsentViewState.SIMPLE || viewState === UniversalCookieConsentViewState.ADVANCED)) {
            this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
        }
        else {
            this.renderer.removeStyle(this.document.body, 'overflow');
        }
    }
    /**
     * Automatically show the consent modal if the autoShow options is set and the autoShow conditions are met
     * @param viewState
     * @param options
     * @param consents
     */
    handleAutoShow(viewState, options, consents) {
        if (options.autoShow && viewState === UniversalCookieConsentViewState.CLOSED && consents === null) {
            this.show();
        }
    }
};
UniversalCookieConsentService.ɵfac = function UniversalCookieConsentService_Factory(t) { return new (t || UniversalCookieConsentService)(ɵngcc0.ɵɵinject(UNIVERSAL_COOKIE_CONSENT_OPTIONS, 8), ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2)); };
UniversalCookieConsentService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UniversalCookieConsentService, factory: function (t) { return UniversalCookieConsentService.ɵfac(t); } });
UniversalCookieConsentService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [UNIVERSAL_COOKIE_CONSENT_OPTIONS,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: RendererFactory2 }
];
UniversalCookieConsentService = __decorate([ __param(0, Optional()), __param(0, Inject(UNIVERSAL_COOKIE_CONSENT_OPTIONS)),
    __param(1, Inject(DOCUMENT)),
    __param(2, Inject(PLATFORM_ID)),
    __metadata("design:paramtypes", [Object, Object, Object,
        RendererFactory2])
], UniversalCookieConsentService);

let UniversalCookieConsentComponent = class UniversalCookieConsentComponent {
    constructor(service, fb) {
        this.service = service;
        this.fb = fb;
        this.ViewState = UniversalCookieConsentViewState;
        this.viewState$ = this.service.getViewState().pipe(shareReplay(1));
        this.options$ = this.service.getOptions().pipe(shareReplay(1));
        this.showModal$ = this.service.getViewState().pipe(map(viewState => {
            return viewState === UniversalCookieConsentViewState.SIMPLE
                || viewState === UniversalCookieConsentViewState.ADVANCED;
        }), shareReplay(1));
        this.grantedConsents$ = this.service.getGrantedConsents();
    }
    ngOnInit() {
        this.subscription = combineLatest(this.grantedConsents$, this.options$).subscribe(([grantedConsents, options]) => {
            this.updateCustomizeForm(grantedConsents, options);
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * Called when the user clicks the accept button, grants all consents and closes the modal
     */
    onAcceptClicked() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = yield this.options$.pipe(take(1)).toPromise();
            const consentTypes = options.consentTypes;
            if (consentTypes) {
                this.service.setGrantedConsents(consentTypes.map(type => type.id));
                this.service.setViewState(UniversalCookieConsentViewState.CLOSED);
            }
        });
    }
    /**
     * Called when the user clicks the customize button, switches the view state
     */
    onCustomizeClicked() {
        this.service.setViewState(UniversalCookieConsentViewState.ADVANCED);
    }
    /**
     * Called when the user clicks the back button, switches the view state
     */
    onBackClicked() {
        this.service.setViewState(UniversalCookieConsentViewState.SIMPLE);
    }
    /**
     * Called when the user clicks the save button, updates the granted consents and closed the modal
     */
    onSaveCustomizedClicked() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = yield this.options$.pipe(take(1)).toPromise();
            const availableConsentTypes = options.consentTypes;
            const currentValue = this.customizeFormGroup.value;
            const grantedConsentTypes = Object.keys(currentValue).filter(consentType => currentValue[consentType]);
            const mandatoryConsentTypes = availableConsentTypes.filter(consentType => consentType.mandatory).map(consentType => consentType.id);
            this.service.setGrantedConsents([...mandatoryConsentTypes, ...grantedConsentTypes]);
            this.service.setViewState(UniversalCookieConsentViewState.CLOSED);
        });
    }
    /**
     * Update the form with the given options
     * @param grantedConsents
     * @param options
     */
    updateCustomizeForm(grantedConsents, options) {
        const controls = options.consentTypes ? options.consentTypes.reduce((types, type) => {
            return Object.assign(Object.assign({}, types), { [type.id]: [
                    {
                        value: Boolean(type.mandatory) || (grantedConsents || []).includes(type.id),
                        disabled: Boolean(type.mandatory)
                    }
                ] });
        }, {}) : {};
        this.customizeFormGroup = this.fb.group(controls);
    }
};
UniversalCookieConsentComponent.ɵfac = function UniversalCookieConsentComponent_Factory(t) { return new (t || UniversalCookieConsentComponent)(ɵngcc0.ɵɵdirectiveInject(UniversalCookieConsentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.FormBuilder)); };
UniversalCookieConsentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UniversalCookieConsentComponent, selectors: [["universal-cookie-consent"]], decls: 2, vars: 3, consts: [[4, "ngIf"], ["simple", ""], ["advanced", ""], [1, "ucc-backdrop"], [1, "ucc-modal"], [4, "ngIf", "ngIfElse"], [4, "ngTemplateOutlet"], ["class", "ucc-logo", 3, "src", 4, "ngIf"], [1, "ucc-intro", 3, "innerHTML"], [1, "ucc-buttons"], ["type", "button", 1, "ucc-button", "ucc-button--secondary", 3, "click"], ["type", "button", 1, "ucc-button", "ucc-button--primary", 3, "click"], [1, "ucc-logo", 3, "src"], [1, "ucc-heading"], [1, "ucc-intro"], [1, "ucc-consent-types", 3, "formGroup"], ["class", "ucc-consent-type", 4, "ngFor", "ngForOf"], [1, "ucc-consent-type"], [1, "ucc-consent-type__control", 3, "formControlName"], [1, "ucc-consent-type__content"], [1, "ucc-consent-type__title"], [1, "ucc-consent-type__description", 3, "innerHTML"]], template: function UniversalCookieConsentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, UniversalCookieConsentComponent_ng_container_0_Template, 7, 3, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.options$));
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc1.ɵNgNoValidate, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgForOf, UiSwitchComponent, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName]; }, pipes: function () { return [ɵngcc2.AsyncPipe]; }, styles: [".ucc-backdrop[_ngcontent-%COMP%]{background:var(--ucc-backdrop-color);position:fixed;top:0;left:0;right:0;bottom:0;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;z-index:var(--ucc-z-index,99999)}.ucc-modal[_ngcontent-%COMP%]{background:var(--ucc-modal-background);max-width:var(--ucc-modal-width);width:100%;min-height:10rem;padding:var(--ucc-modal-padding);font-family:var(--ucc-font-family)}.ucc-heading[_ngcontent-%COMP%]{margin:0 0 2rem;font-size:var(--ucc-heading-size);font-weight:var(--ucc-heading-weight)}.ucc-logo[_ngcontent-%COMP%]{display:block;margin-left:auto;margin-right:auto;margin-bottom:4rem}.ucc-intro[_ngcontent-%COMP%]{margin-bottom:4rem}.ucc-buttons[_ngcontent-%COMP%]{display:-webkit-box;display:flex;margin-left:calc(-1 * var(--ucc-button-spacing));margin-right:calc(-1 * var(--ucc-button-spacing))}.ucc-buttons[_ngcontent-%COMP%]   .ucc-button[_ngcontent-%COMP%]{flex-basis:50%}.ucc-button[_ngcontent-%COMP%]{border:0;margin:0 var(--ucc-button-spacing);padding:var(--ucc-button-padding-x) var(--ucc-button-padding-x);background:0 0;font-family:inherit;font-size:var(--ucc-button-font-size);border-radius:var(--ucc-button-radius);font-weight:var(--ucc-button-weight)}.ucc-button--primary[_ngcontent-%COMP%]{background-color:var(--ucc-color-primary);color:var(--ucc-color-primary-contrast)}.ucc-button--secondary[_ngcontent-%COMP%]{background-color:var(--ucc-color-secondary);color:var(--ucc-color-secondary-contrast)}.ucc-consent-types[_ngcontent-%COMP%]{margin-bottom:4rem}.ucc-consent-type[_ngcontent-%COMP%]{display:-webkit-box;display:flex;margin-bottom:1rem}.ucc-consent-type__control[_ngcontent-%COMP%]{margin-right:1rem}.ucc-consent-type__content[_ngcontent-%COMP%]{-webkit-box-flex:1;flex:1}.ucc-consent-type__title[_ngcontent-%COMP%]{margin:0 0 .25rem;font-size:var(--ucc-consent-type-title-size);font-weight:var(--ucc-consent-type-title-weight)}.ucc-consent-type__description[_ngcontent-%COMP%]{margin:0;font-size:var(--ucc-consent-type-description-size);color:var(--ucc-consent-type-description-color)}"], changeDetection: 0 });
UniversalCookieConsentComponent.ctorParameters = () => [
    { type: UniversalCookieConsentService },
    { type: FormBuilder }
];
UniversalCookieConsentComponent = __decorate([ __metadata("design:paramtypes", [UniversalCookieConsentService, FormBuilder])
], UniversalCookieConsentComponent);

let UniversalCookieConsentContainerComponent = class UniversalCookieConsentContainerComponent {
    constructor(service) {
        this.service = service;
        this.viewState = UniversalCookieConsentViewState.CLOSED;
        this.disableBodyScroll = false;
        this.update = new EventEmitter();
    }
    ngOnInit() {
        this.subscription = this.service.getGrantedConsents().subscribe(this.update);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    ngOnChanges(changes) {
        this.updateOptions();
        this.updateViewState();
    }
    updateOptions() {
        this.service.setOptions({
            consentTypes: this.consentTypes,
            logoUrl: this.logoUrl,
            introText: this.introText,
            customizeText: this.customizeText,
            acceptText: this.acceptText,
            customizeHeadingText: this.customizeHeadingText,
            customizeIntroText: this.customizeIntroText,
            backText: this.backText,
            saveText: this.saveText,
            disableBodyScroll: this.disableBodyScroll
        });
    }
    updateViewState() {
        this.service.setViewState(this.viewState);
    }
};
UniversalCookieConsentContainerComponent.ɵfac = function UniversalCookieConsentContainerComponent_Factory(t) { return new (t || UniversalCookieConsentContainerComponent)(ɵngcc0.ɵɵdirectiveInject(UniversalCookieConsentService)); };
UniversalCookieConsentContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UniversalCookieConsentContainerComponent, selectors: [["universal-cookie-consent-container"]], inputs: { viewState: "viewState", disableBodyScroll: "disableBodyScroll", consentTypes: "consentTypes", logoUrl: "logoUrl", introText: "introText", customizeText: "customizeText", acceptText: "acceptText", customizeHeadingText: "customizeHeadingText", customizeIntroText: "customizeIntroText", backText: "backText", saveText: "saveText" }, outputs: { update: "update" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 0, template: function UniversalCookieConsentContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "universal-cookie-consent");
    } }, directives: [UniversalCookieConsentComponent], encapsulation: 2 });
UniversalCookieConsentContainerComponent.ctorParameters = () => [
    { type: UniversalCookieConsentService }
];
__decorate([
    Input(),
    __metadata("design:type", Number)
], UniversalCookieConsentContainerComponent.prototype, "viewState", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], UniversalCookieConsentContainerComponent.prototype, "consentTypes", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UniversalCookieConsentContainerComponent.prototype, "logoUrl", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UniversalCookieConsentContainerComponent.prototype, "introText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UniversalCookieConsentContainerComponent.prototype, "customizeText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UniversalCookieConsentContainerComponent.prototype, "acceptText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UniversalCookieConsentContainerComponent.prototype, "customizeHeadingText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UniversalCookieConsentContainerComponent.prototype, "customizeIntroText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UniversalCookieConsentContainerComponent.prototype, "backText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UniversalCookieConsentContainerComponent.prototype, "saveText", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UniversalCookieConsentContainerComponent.prototype, "disableBodyScroll", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UniversalCookieConsentContainerComponent.prototype, "update", void 0);
UniversalCookieConsentContainerComponent = __decorate([ __metadata("design:paramtypes", [UniversalCookieConsentService])
], UniversalCookieConsentContainerComponent);

const UI_SWITCH_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UiSwitchComponent),
    multi: true,
};
let UiSwitchComponent = class UiSwitchComponent {
    constructor(renderer) {
        this.renderer = renderer;
        /**
         * @description
         * The registered callback function called when a change event occurs on the input element.
         */
        this.onChange = (_) => { };
        /**
         * @description
         * The registered callback function called when a blur event occurs on the input element.
         */
        this.onTouched = () => { };
    }
    /**
     * Sets the "checked" property on the input element.
     *
     * @param value The checked value
     */
    writeValue(value) {
        this.renderer.setProperty(this.checkboxElementRef.nativeElement, 'checked', value);
    }
    /**
     * @description
     * Registers a function called when the control value changes.
     *
     * @param fn The callback function
     */
    registerOnChange(fn) { this.onChange = fn; }
    /**
     * @description
     * Registers a function called when the control is touched.
     *
     * @param fn The callback function
     */
    registerOnTouched(fn) { this.onTouched = fn; }
    /**
     * Sets the "disabled" property on the input element.
     *
     * @param isDisabled The disabled value
     */
    setDisabledState(isDisabled) {
        this.renderer.setProperty(this.checkboxElementRef.nativeElement, 'disabled', isDisabled);
    }
};
UiSwitchComponent.ɵfac = function UiSwitchComponent_Factory(t) { return new (t || UiSwitchComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
UiSwitchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UiSwitchComponent, selectors: [["ui-switch"]], viewQuery: function UiSwitchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.checkboxElementRef = _t.first);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([UI_SWITCH_VALUE_ACCESSOR])], decls: 4, vars: 0, consts: [["type", "checkbox", 3, "change"], ["checkbox", ""]], template: function UiSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label");
        ɵngcc0.ɵɵelementStart(1, "input", 0, 1);
        ɵngcc0.ɵɵlistener("change", function UiSwitchComponent_Template_input_change_1_listener($event) { return ctx.onChange($event.target.checked); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "span");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%]{position:relative;display:inline-block;width:var(--ucc-switch-width);height:var(--ucc-switch-height);color:var(--ucc-color-primary)}[_nghost-%COMP%]   input[_ngcontent-%COMP%]{display:none}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:checked + span[_ngcontent-%COMP%]{background-color:currentColor}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:checked + span[_ngcontent-%COMP%]:before{left:calc(var(--ucc-switch-width) - var(--ucc-switch-toggle-size) - ((var(--ucc-switch-height) - var(--ucc-switch-toggle-size))/ 2))}[_nghost-%COMP%]   input[_ngcontent-%COMP%]:disabled + span[_ngcontent-%COMP%]{opacity:.5}[_nghost-%COMP%]   span[_ngcontent-%COMP%]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:var(--ucc-switch-background);-webkit-transition:.3s;transition:.3s;border-radius:var(--ucc-switch-radius)}[_nghost-%COMP%]   span[_ngcontent-%COMP%]:before{content:\"\";position:absolute;width:var(--ucc-switch-toggle-size);height:var(--ucc-switch-toggle-size);left:calc((var(--ucc-switch-height) - var(--ucc-switch-toggle-size))/ 2);top:calc((var(--ucc-switch-height) - var(--ucc-switch-toggle-size))/ 2);background-color:#fff;-webkit-transition:.3s;transition:.3s;border-radius:var(--ucc-switch-toggle-radius)}"] });
UiSwitchComponent.ctorParameters = () => [
    { type: Renderer2 }
];
__decorate([
    ViewChild('checkbox', { read: ElementRef, static: true }),
    __metadata("design:type", ElementRef)
], UiSwitchComponent.prototype, "checkboxElementRef", void 0);
UiSwitchComponent = __decorate([ __metadata("design:paramtypes", [Renderer2])
], UiSwitchComponent);

var UniversalCookieConsentModule_1;
const DEFAULT_MODULE_PROVIDERS = [
    UniversalCookieConsentService
];
const UNIVERSAL_COOKIE_CONSENT_OPTION_DEFAULTS = {
    acceptText: 'Accept',
    customizeText: 'Customize',
    backText: 'Back',
    saveText: 'Save',
    customizeHeadingText: 'Cookie Settings'
};
let UniversalCookieConsentModule = UniversalCookieConsentModule_1 = class UniversalCookieConsentModule {
    static forRoot(options) {
        return {
            ngModule: UniversalCookieConsentModule_1,
            providers: [
                ...DEFAULT_MODULE_PROVIDERS,
                {
                    provide: UNIVERSAL_COOKIE_CONSENT_OPTIONS,
                    useValue: Object.assign(Object.assign({}, UNIVERSAL_COOKIE_CONSENT_OPTION_DEFAULTS), options)
                }
            ]
        };
    }
    constructor() {
    }
};
UniversalCookieConsentModule.ɵfac = function UniversalCookieConsentModule_Factory(t) { return new (t || UniversalCookieConsentModule)(); };
UniversalCookieConsentModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UniversalCookieConsentModule });
UniversalCookieConsentModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: DEFAULT_MODULE_PROVIDERS, imports: [[
            CommonModule,
            ReactiveFormsModule
        ]] });
UniversalCookieConsentModule = UniversalCookieConsentModule_1 = __decorate([ __metadata("design:paramtypes", [])
], UniversalCookieConsentModule);

var UniversalCookieConsentDummyModule_1;
let UniversalCookieConsentDummyComponent = class UniversalCookieConsentDummyComponent {
    constructor() { }
};
UniversalCookieConsentDummyComponent.ɵfac = function UniversalCookieConsentDummyComponent_Factory(t) { return new (t || UniversalCookieConsentDummyComponent)(); };
UniversalCookieConsentDummyComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UniversalCookieConsentDummyComponent, selectors: [["universal-cookie-consent"]], decls: 0, vars: 0, template: function UniversalCookieConsentDummyComponent_Template(rf, ctx) { }, encapsulation: 2 });
UniversalCookieConsentDummyComponent = __decorate([ __metadata("design:paramtypes", [])
], UniversalCookieConsentDummyComponent);
let UniversalCookieConsentDummyService = class UniversalCookieConsentDummyService {
    getGrantedConsents() {
        return of([]);
    }
    setGrantedConsents() {
        return;
    }
    getViewState() {
        return of(UniversalCookieConsentViewState.CLOSED);
    }
    getOptions() {
        return never();
    }
    setViewState() {
        return;
    }
    setOptions() {
        return;
    }
    show() {
        return;
    }
};
UniversalCookieConsentDummyService.ɵfac = function UniversalCookieConsentDummyService_Factory(t) { return new (t || UniversalCookieConsentDummyService)(); };
UniversalCookieConsentDummyService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: UniversalCookieConsentDummyService, factory: function (t) { return UniversalCookieConsentDummyService.ɵfac(t); } });
let UniversalCookieConsentDummyModule = UniversalCookieConsentDummyModule_1 = class UniversalCookieConsentDummyModule {
    static forRoot() {
        return {
            ngModule: UniversalCookieConsentDummyModule_1,
            providers: [
                {
                    provide: UniversalCookieConsentService,
                    useValue: new UniversalCookieConsentDummyService()
                }
            ]
        };
    }
    constructor() {
    }
};
UniversalCookieConsentDummyModule.ɵfac = function UniversalCookieConsentDummyModule_Factory(t) { return new (t || UniversalCookieConsentDummyModule)(); };
UniversalCookieConsentDummyModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UniversalCookieConsentDummyModule });
UniversalCookieConsentDummyModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
UniversalCookieConsentDummyModule = UniversalCookieConsentDummyModule_1 = __decorate([ __metadata("design:paramtypes", [])
], UniversalCookieConsentDummyModule);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UniversalCookieConsentService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [UNIVERSAL_COOKIE_CONSENT_OPTIONS]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.RendererFactory2 }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UniversalCookieConsentComponent, [{
        type: Component,
        args: [{
                selector: 'universal-cookie-consent',
                template: "<ng-container *ngIf=\"(options$ | async) as options\">\n    <ng-container *ngIf=\"showModal$ | async\">\n        <div class=\"ucc-backdrop\">\n            <div class=\"ucc-modal\">\n                <ng-container *ngIf=\"(viewState$ | async) === ViewState.SIMPLE; else: advanced\">\n                    <ng-container *ngTemplateOutlet=\"simple\"></ng-container>\n                </ng-container>\n            </div>\n        </div>\n    </ng-container>\n\n    <ng-template #simple>\n        <img class=\"ucc-logo\" *ngIf=\"options.logoUrl\" [src]=\"options.logoUrl\"/>\n\n        <p class=\"ucc-intro\" [innerHTML]=\"options.introText\"></p>\n\n        <div class=\"ucc-buttons\">\n            <button class=\"ucc-button ucc-button--secondary\" type=\"button\"\n                    (click)=\"onCustomizeClicked()\">{{ options.customizeText }}</button>\n            <button class=\"ucc-button ucc-button--primary\" type=\"button\" (click)=\"onAcceptClicked()\">{{ options.acceptText }}</button>\n        </div>\n    </ng-template>\n\n    <ng-template #advanced>\n        <h1 class=\"ucc-heading\">{{ options.customizeHeadingText }}</h1>\n        <p class=\"ucc-intro\">{{ options.customizeIntroText }}</p>\n        <form class=\"ucc-consent-types\" [formGroup]=\"customizeFormGroup\">\n            <div class=\"ucc-consent-type\" *ngFor=\"let consentType of options.consentTypes\">\n                <ui-switch class=\"ucc-consent-type__control\" [formControlName]=\"consentType.id\" [style.color]=\"consentType.color\"></ui-switch>\n                <div class=\"ucc-consent-type__content\">\n                    <h2 class=\"ucc-consent-type__title\">{{ consentType.title }}</h2>\n                    <p class=\"ucc-consent-type__description\" [innerHTML]=\"consentType.description\"></p>\n                </div>\n            </div>\n        </form>\n        <div class=\"ucc-buttons\">\n            <button class=\"ucc-button ucc-button--secondary\" type=\"button\"\n                    (click)=\"onBackClicked()\">{{ options.backText }}</button>\n            <button class=\"ucc-button ucc-button--primary\" type=\"button\" (click)=\"onSaveCustomizedClicked()\">{{ options.saveText }}</button>\n        </div>\n    </ng-template>\n</ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".ucc-backdrop{background:var(--ucc-backdrop-color);position:fixed;top:0;left:0;right:0;bottom:0;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;z-index:var(--ucc-z-index,99999)}.ucc-modal{background:var(--ucc-modal-background);max-width:var(--ucc-modal-width);width:100%;min-height:10rem;padding:var(--ucc-modal-padding);font-family:var(--ucc-font-family)}.ucc-heading{margin:0 0 2rem;font-size:var(--ucc-heading-size);font-weight:var(--ucc-heading-weight)}.ucc-logo{display:block;margin-left:auto;margin-right:auto;margin-bottom:4rem}.ucc-intro{margin-bottom:4rem}.ucc-buttons{display:-webkit-box;display:flex;margin-left:calc(-1 * var(--ucc-button-spacing));margin-right:calc(-1 * var(--ucc-button-spacing))}.ucc-buttons .ucc-button{flex-basis:50%}.ucc-button{border:0;margin:0 var(--ucc-button-spacing);padding:var(--ucc-button-padding-x) var(--ucc-button-padding-x);background:0 0;font-family:inherit;font-size:var(--ucc-button-font-size);border-radius:var(--ucc-button-radius);font-weight:var(--ucc-button-weight)}.ucc-button--primary{background-color:var(--ucc-color-primary);color:var(--ucc-color-primary-contrast)}.ucc-button--secondary{background-color:var(--ucc-color-secondary);color:var(--ucc-color-secondary-contrast)}.ucc-consent-types{margin-bottom:4rem}.ucc-consent-type{display:-webkit-box;display:flex;margin-bottom:1rem}.ucc-consent-type__control{margin-right:1rem}.ucc-consent-type__content{-webkit-box-flex:1;flex:1}.ucc-consent-type__title{margin:0 0 .25rem;font-size:var(--ucc-consent-type-title-size);font-weight:var(--ucc-consent-type-title-weight)}.ucc-consent-type__description{margin:0;font-size:var(--ucc-consent-type-description-size);color:var(--ucc-consent-type-description-color)}"]
            }]
    }], function () { return [{ type: UniversalCookieConsentService }, { type: ɵngcc1.FormBuilder }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UniversalCookieConsentContainerComponent, [{
        type: Component,
        args: [{
                selector: 'universal-cookie-consent-container',
                template: "<universal-cookie-consent></universal-cookie-consent>\n"
            }]
    }], function () { return [{ type: UniversalCookieConsentService }]; }, { viewState: [{
            type: Input
        }], disableBodyScroll: [{
            type: Input
        }], update: [{
            type: Output
        }], consentTypes: [{
            type: Input
        }], logoUrl: [{
            type: Input
        }], introText: [{
            type: Input
        }], customizeText: [{
            type: Input
        }], acceptText: [{
            type: Input
        }], customizeHeadingText: [{
            type: Input
        }], customizeIntroText: [{
            type: Input
        }], backText: [{
            type: Input
        }], saveText: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiSwitchComponent, [{
        type: Component,
        args: [{
                selector: 'ui-switch',
                template: "<label>\n    <input #checkbox type=\"checkbox\" (change)=\"onChange($event.target.checked)\">\n    <span></span>\n</label>\n",
                providers: [UI_SWITCH_VALUE_ACCESSOR],
                styles: [":host{position:relative;display:inline-block;width:var(--ucc-switch-width);height:var(--ucc-switch-height);color:var(--ucc-color-primary)}:host input{display:none}:host input:checked+span{background-color:currentColor}:host input:checked+span:before{left:calc(var(--ucc-switch-width) - var(--ucc-switch-toggle-size) - ((var(--ucc-switch-height) - var(--ucc-switch-toggle-size))/ 2))}:host input:disabled+span{opacity:.5}:host span{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:var(--ucc-switch-background);-webkit-transition:.3s;transition:.3s;border-radius:var(--ucc-switch-radius)}:host span:before{content:\"\";position:absolute;width:var(--ucc-switch-toggle-size);height:var(--ucc-switch-toggle-size);left:calc((var(--ucc-switch-height) - var(--ucc-switch-toggle-size))/ 2);top:calc((var(--ucc-switch-height) - var(--ucc-switch-toggle-size))/ 2);background-color:#fff;-webkit-transition:.3s;transition:.3s;border-radius:var(--ucc-switch-toggle-radius)}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { checkboxElementRef: [{
            type: ViewChild,
            args: ['checkbox', { read: ElementRef, static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UniversalCookieConsentModule, [{
        type: NgModule,
        args: [{
                declarations: [UniversalCookieConsentComponent, UniversalCookieConsentContainerComponent, UiSwitchComponent],
                imports: [
                    CommonModule,
                    ReactiveFormsModule
                ],
                exports: [UniversalCookieConsentComponent, UniversalCookieConsentContainerComponent],
                providers: DEFAULT_MODULE_PROVIDERS
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UniversalCookieConsentModule, { declarations: function () { return [UniversalCookieConsentComponent, UniversalCookieConsentContainerComponent, UiSwitchComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule]; }, exports: function () { return [UniversalCookieConsentComponent, UniversalCookieConsentContainerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UniversalCookieConsentDummyComponent, [{
        type: Component,
        args: [{
                selector: 'universal-cookie-consent',
                template: ''
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UniversalCookieConsentDummyService, [{
        type: Injectable
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UniversalCookieConsentDummyModule, [{
        type: NgModule,
        args: [{
                declarations: [UniversalCookieConsentDummyComponent],
                imports: [
                    CommonModule
                ],
                exports: [UniversalCookieConsentDummyComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UniversalCookieConsentDummyModule, { declarations: function () { return [UniversalCookieConsentDummyComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [UniversalCookieConsentDummyComponent]; } }); })();

/*
 * Public API Surface of universal-cookie-consent
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DEFAULT_MODULE_PROVIDERS, UNIVERSAL_COOKIE_CONSENT_OPTIONS, UNIVERSAL_COOKIE_CONSENT_OPTION_DEFAULTS, UniversalCookieConsentComponent, UniversalCookieConsentContainerComponent, UniversalCookieConsentDummyComponent, UniversalCookieConsentDummyModule, UniversalCookieConsentDummyService, UniversalCookieConsentModule, UniversalCookieConsentService, UniversalCookieConsentViewState, UI_SWITCH_VALUE_ACCESSOR as ɵa, UiSwitchComponent as ɵb };

//# sourceMappingURL=universal-cookie-consent.js.map